export enum DIALOG_TYPES {
  EDIT,
  DELETE,
  RESET_PASSWORD,
  DELETE_REPLICA,
  RESTORE_BACKUP,
  RESTORE_SET,
  ROLLBACK_RESTORE,
  CREATE_BACKUP,
  CREATE_REPLICA,
  DELETE_CRON,
  EDIT_CUSTOM_OPTION,
  CREATE_DATABASE_CHILD,
  DELETE_DATABASE_CHILD,
  CREATE_DATABASE_USER,
  DELETE_DATABASE_USER,
  SET_PERMISSIONS,
  EDIT_DATABASE_CHILD_EXTENSIONS,
  EDIT_DATABASE_CHILD_SETTINGS
}

export enum TABS {
  DATABASES,
  USERS,
  REPLICAS,
  BACKUPS,
  CUSTOM_OPTIONS,
  NETWORK
}

export enum BACKUP_VIEWS {
  SETS = "sets",
  FILES = "files"
}
